
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { TRANSLATIONS_FETCH } from "@/store/ActionTypes";

import UserRepository from "@/utils/API/UserRepository";


import vTabbedContent from "@/components/vTabbedContent.vue";


@Component({
  components: {
    vTabbedContent
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    })
  }
})
class AccountSettings extends Vue {
  localizationState: any;

  changePassword = {
    oldPassword: "",
    newPassword: "",
    repeatNewPassword: ""
  };

  get tabs() {
    return [{ id: 1, name: this.translations.get("profile_tab_password") }];
  }

  submitChangePassword() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        // @ts-ignore
        this.$snotify.async(
          this.translations.get("profile_toastr_password_updating"),
          () =>
            new Promise((resolve, reject) => {
              UserRepository.changePassword({
                oldPassword: this.changePassword.oldPassword,
                newPassword: this.changePassword.newPassword,
                repeatNewPassword: this.changePassword.repeatNewPassword
              })
                .then(() => {
                  resolve({
                    body: this.translations.get(
                      "toastr_toastr_password_updated"
                    )
                  });
                  this.$router.push("/");
                })
                .catch((error) => {
                  let message = "";
                  if (error.response) {
                    message =
                      error.response.data.errorMessages[0].userVisibleMessage;
                  }
                  else {
                    message = this.translations.get("network_error");
                  }
                  reject({ body: message });
                });
            }),
          {
            timeout: 3500,
            closeOnClick: true
          }
        );
        return;
      }
      this.$snotify.error(this.translations.get("validation-error-message"));
    });
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    this.$store.dispatch(TRANSLATIONS_FETCH, {
      category: "pages",
      collections: ["common", "profile", "customers"]
    });

    document.title = 'Account Settings | MenuSano';
  }
}
export default AccountSettings;
